class TrialApproved {
    constructor() {
        let searchParams = new URLSearchParams(window.location.search);
        this.organizationID = searchParams.get('organizationID');
    }
    closeTrial(){
        $.ajax({
            url: '/?do=CloseTrialApproved',
            type: 'GET',
            dataType: '',
            data: { organizationID: this.organizationID},
        }).done(function() {
            $('.info-banner').fadeOut(500, function() {
                $(this).remove();
            });
        });
    }
    secureSystems(){
        $.ajax({
            url: '/?do=UpdateWizardStep',
            type: 'GET',
            dataType: '',
            data: { organizationID: this.organizationID, wizardStep: 1},
        }).done(function(data) {
            window.location.href = data;
        });
    }
    downloadApp(){
        $.ajax({
            url: '/?do=UpdateWizardStep',
            type: 'GET',
            dataType: '',
            data: { organizationID: this.organizationID, wizardStep: 2},
        }).done(function(data) {
            window.location.href = data;
        });
    }
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    const trialApproved = new TrialApproved();
    $(document).on('click','.trial-decision-cross',function(){
        trialApproved.closeTrial()
    });
    $(document).on('click','.trial-secure-systems',function(){
        trialApproved.secureSystems();
    });
    $(document).on('click','.trial-download-app',function(){
        trialApproved.downloadApp();
    });
});